import React, { Component } from 'react';


class YX extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {
    
        return (
            <section>
            
            <section className="container section">
                <h4 className="titleENG center">YX</h4>

                <div className="row">
                    <div className="col m5 l5">
                        <img src="../img/me.jpg" alt="" className="responsive-img"></img>
                    </div>
                    <div className="col m5 l5  push-m1 push-l1 ">
                        <p className="YXdetailP"><strong>YX, or Yueqing Xie, </strong>is a software developer. She loves traveling, dancing, drawing, and playing instruments, and values a balanced, creative lifestyle. </p>
                        <br/>
                        <div className="YXdetail">
                            <p className="YXdetailP"><strong>Full name: </strong>Yueqing Xie</p>
                            <p className="YXdetailP"><strong>Education: </strong>Bachelor’s Degree in Joint Honours in Computer Science and Mathematics.</p>
                            <p className="YXdetailP"><strong>Birthday: </strong>January 26</p>
                            <p className="YXdetailP"><strong>MBTI: </strong>INTJ-A</p>
                            <p className="YXdetailP"><strong>Height: </strong>169cm</p>
                            <p className="YXdetailP"><strong>Weight: </strong>50kg</p>
                        </div>
                    </div>
                </div>

                <h4 className="titleENG center">Some Pictures...</h4>    

                
                <div className="row">
                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/16.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/15.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/14.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/13.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/2.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/4.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/3.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/1.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/12.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/11.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/10.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/9.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/8.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/7.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/6.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>

                    <div className="col s12 m3 l3">
                        <div className="card">
                        <div className="card-image">
                            <img src="../YX/5.JPG" alt="" className="responsive-img materialboxed"/>
                        </div>
                        </div>
                    </div>
                </div>

            </section>
  
            </section>
        )
    }
}




export default YX;
